import {
  Button,
  Card,
  Chip,
  CircularProgress,
  IconButton,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import ViewStudent from '../Student/ViewStudent';
import { useDispatch, useSelector } from 'react-redux';
import {
  getStudentHistoryClasses,
  getStudentPastMarksPayments,
} from '../../features/history/HistorySlice';
import { getLabelsByInstituteType } from '../../utils/constants';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModalDialog from '../UIElements/ModalDialog';
import ReusableMUITable from '../UIElements/ReusableMUITable';
import { Cancel, CheckCircle } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import { BsFileEarmarkPdf } from 'react-icons/bs';
import api from '../../services/api';
function StudentHistory() {
  const [studentId, setStudentId] = useState('');
  const [searchValue, setSearchValue] = useState('');
  return (
    <>
      {' '}
      <Card className=' p-4 border-t max-w-5xl'>
        {' '}
        <div className='max-w-5xl pb-6 '>
          <Typography variant='h6' className='text-blue-600'>
            {' '}
            Search Student
          </Typography>
          <Card className=' mb-4 p-4 border rounded'>
            <Typography variant='body1' className='mb-2'>
              Enter Student Id and search for the payments history detials.
            </Typography>
            <div className='flex items-end flex-wrap gap-2'>
              <TextField
                value={searchValue}
                id='studentId'
                size='small'
                label='Student Id'
                className=' mr-10 mt-2 w-60'
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>
                      {!!searchValue && (
                        <IconButton
                          onClick={() => {
                            setSearchValue('');
                            setStudentId('');
                          }}
                        >
                          <CloseIcon></CloseIcon>
                        </IconButton>
                      )}
                    </InputAdornment>
                  ),
                }}
                onChange={(e) => setSearchValue(e.target.value)}
              ></TextField>

              <Button
                variant='contained'
                disabled={!searchValue}
                onClick={() => setStudentId(searchValue)}
              >
                Search
              </Button>
            </div>
          </Card>
          <Typography variant='h6' className='text-blue-600'>
            {' '}
            Student Details
          </Typography>
          <Card className='p-3 border'>
            <ViewStudent StudentId={studentId} />
          </Card>
          <PreviousDetails StudentId={studentId} />
        </div>
      </Card>
    </>
  );
}
export default StudentHistory;

export const PreviousDetails = ({ StudentId }) => {
  const [previousData, setPreviousData] = useState([]); //This contains the previous classes details
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch(0);
  let { instituteType } = useSelector((state) => {
    return state.auth?.successData?.userDetails ?? {};
  });
  let { Department, Class, Section } = getLabelsByInstituteType(instituteType);
  useEffect(() => {
    (async () => {
      if (StudentId) {
        setLoading(true);
        try {
          const response = await dispatch(
            getStudentHistoryClasses(StudentId),
          ).unwrap();
          setPreviousData(response.data);
        } catch (error) {
          console.log(error);
        } finally {
          setLoading(false);
        }
      } else {
        setPreviousData([]);
      }
    })();
  }, [StudentId]);
  return (
    <>
      <Typography variant='h6' className='text-blue-600 mb-2 ml-2 mt-5'>
        Previous Classes Details
      </Typography>
      {/* Loading status for the Student Details */}
      {loading && previousData?.length == 0 && (
        <Card className='border rounded  h-64 flex items-center justify-center gap-4 '>
          <CircularProgress></CircularProgress>
          <Typography variant='body1'>
            Fetching the history details of {StudentId}
          </Typography>
        </Card>
      )}
      {!StudentId && (
        <Card className='flex items-center justify-center h-64 border-t'>
          <div className='flex flex-col justify-center items-center h-60  rounded-lg'>
            <PersonIcon
              className='text-gray-300 mb-1 animate-pulse'
              style={{ fontSize: 90 }}
            />
            <Typography variant='h6' className='text-gray-400 mb-2'>
              No Student Selected
            </Typography>
            <Typography variant='body2' className='text-gray-500'>
              Please search by Student Id to know the payment details.
            </Typography>
          </div>
        </Card>
      )}
      {/* No Data Message for the Studenet Details */}
      {StudentId && previousData?.length == 0 && !loading && (
        <Card className='flex items-center justify-center h-64 border-t'>
          <Typography variant='body1'>
            No previous history details found for <b>{StudentId}</b>
          </Typography>
        </Card>
      )}
      {/* Previous Classes Details View */}
      {previousData?.length > 0 && (
        <>
          <Card className=''>
            <div className='overflow-x-auto'>
              {' '}
              <TableContainer
                component={Paper}
                variant='outlined'
                sx={{
                  maxHeight: 600,
                  overflow: 'auto',
                }}
              >
                <Table stickyHeader size='small' sx={{ minWidth: 600 }}>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: '#f8fafc' }}>
                      <TableCell className='text-blue-600'>
                        <strong>Student Id</strong>
                      </TableCell>
                      <TableCell className='text-blue-600'>
                        <strong>{Department}</strong>
                      </TableCell>
                      <TableCell className='text-blue-600'>
                        <strong>{Class}</strong>
                      </TableCell>
                      {instituteType?.toLowerCase() === 'college' && (
                        <TableCell className='text-blue-600'>
                          <strong>{Section}</strong>
                        </TableCell>
                      )}
                      <TableCell className='text-blue-600'>
                        <strong>Academic Year</strong>
                      </TableCell>
                      <TableCell className='text-blue-600'>
                        <strong>Details</strong>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {previousData?.map((obj) => (
                      <TableRow
                        key={obj?.id}
                        hover
                        sx={{
                          '&:nth-of-type(odd)': {
                            backgroundColor: '#fafafa',
                          },
                        }}
                      >
                        <TableCell>{obj.studentId}</TableCell>

                        <TableCell className='truncate max-w-[400px] '>
                          {obj.departmentName}
                        </TableCell>
                        <TableCell className='truncate max-w-[400px] '>
                          {obj.className}
                        </TableCell>
                        {instituteType?.toLowerCase() === 'college' && (
                          <TableCell className='truncate max-w-[220px] '>
                            {obj.sectionName}
                          </TableCell>
                        )}
                        <TableCell className='truncate max-w-[400px] '>
                          {obj.academicYear}
                        </TableCell>
                        <TableCell align='center' className='flex gap-2'>
                          {' '}
                          <ModalView
                            studentId={obj.studentId}
                            academicCode={obj.academicYear}
                          ></ModalView>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>{' '}
            </div>
          </Card>
        </>
      )}
    </>
  );
};
export const ModalView = ({ studentId, academicCode }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pastData, setPastData] = useState({}); //This contains previous data of payments and marks of a particular Academic Year
  const totalFee = pastData?.student?.totalFee;
  const totalPaid = pastData?.payments?.reduce((acc, obj) => {
    return acc + obj.amount;
  }, 0);
  const dispatch = useDispatch();
  async function getMarksAndPayments() {
    if (studentId && academicCode) {
      setLoading(true);
      try {
        const response = await dispatch(
          getStudentPastMarksPayments({
            studentId: studentId,
            academicCode: academicCode,
          }),
        ).unwrap();
        setPastData(response.data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
  }
  async function downloadReceipt(id) {
    try {
      const fileResponse = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/history/payment/download/${id}`,
        method: 'GET',
        responseType: 'blob',
      });
      const blob = new Blob([fileResponse?.data], {
        type: fileResponse.headers['content-type'],
      });

      let filename = `${studentId || 'Receipt'}.pdf`;
      const contentDisposition = fileResponse?.headers['content-disposition'];
      const match = contentDisposition?.match(/filename="?(.+)"?/);

      if (match?.[1]) filename = match[1];

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      alert('Error in Downloading');
      console.error('Download failed', err);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {}, []);
  return (
    <div>
      <IconButton
        onClick={() => {
          setOpen(true);
          getMarksAndPayments();
        }}
      >
        <VisibilityIcon></VisibilityIcon>
      </IconButton>
      {/* Opening the modal */}
      <ModalDialog
        size='md'
        isOpen={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <div>
          {' '}
          {/* Header */}
          <Typography
            variant='h6'
            color='primary'
            className='mb-2 font-semibold'
          >
            Payments and Marks Details of {studentId}
          </Typography>
          {/* Loading */}
          {Object.keys(pastData)?.length == 0 && loading && (
            <Card className='flex items-center justify-center gap-4 min-h-96'>
              <CircularProgress></CircularProgress>{' '}
              <Typography variant='h6' color='primary' className='mb-2'>
                Fetching Student Details of {studentId}
              </Typography>
            </Card>
          )}
          {/* No Data Found */}
          {Object.keys(pastData)?.length == 0 && !loading && (
            <Card className='flex items-center justify-center gap-4 min-h-96'>
              <Typography variant='h6' color='primary' className='mb-2'>
                No details found for {studentId}
              </Typography>
            </Card>
          )}
          {/* First Row */}
          <div className='flex justify-between gap-2'>
            <Typography color='primary' className='mt-4 mb-2 font-semibold'>
              Payment Table
            </Typography>
            <div className='flex gap-2 '>
              {/* Total Fee */}
              {totalFee && (
                <Typography>
                  Total Fee : <b>{totalFee}</b>
                </Typography>
              )}
              {/* Total Paid */}
              {totalPaid > 0 && (
                <>
                  <Typography>
                    Total Paid : <b className='text-green-600'>{totalPaid}</b>
                  </Typography>

                  <Typography></Typography>
                </>
              )}
              {/* Total Due */}
              {totalFee && (
                <Typography>
                  Total Due :{' '}
                  <b className='text-red-600'>{totalFee - totalPaid}</b>
                  {pastData?.student?.writeOffRemaining && '(WrittenOff)'}
                </Typography>
              )}
            </div>
          </div>
          {/* Previous CLass Fees Receipts */}
          {pastData?.payments?.length > 0 ? (
            <ReusableMUITable
              headerNames={[
                'ReceiptNo',
                'Payment Type',
                'Amount',
                'Accountant',
                'Payment Date',
                'Actions',
              ]}
              rowValues={[
                { accessValue: 'receiptNo' },
                { accessValue: 'paymentType' },
                {
                  accessValue: 'amount',
                },
                { accessValue: 'createdBy' },
                { accessValue: 'paidOn' },
                {
                  accessValue: 'id',
                  renderCell: (paymentId, row) => (
                    <Tooltip
                      title='Download Transaction Receipt'
                      enterDelay={0}
                    >
                      <IconButton
                        onClick={() => {
                          downloadReceipt(row[paymentId]);
                        }}
                        className='text-red-600 '
                      >
                        <BsFileEarmarkPdf />
                      </IconButton>
                    </Tooltip>
                  ),
                },
              ]}
              dataList={pastData?.payments ?? []}
            />
          ) : (
            <Card className='flex items-center justify-center  min-h-44 border'>
              <Typography>No Payment Details found for the Student</Typography>
            </Card>
          )}{' '}
          {/* Previous Marks Table */}
          <Typography color='primary' className='mt-4 mb-2 font-semibold'>
            Marks Tables
          </Typography>
          {/* Marks Table */}
          {Object.keys(pastData?.marks ?? {})?.length > 0 ? (
            Object.keys(pastData?.marks ?? {})?.map((specificTest, index) => {
              const specificTestData = pastData?.marks[specificTest];
              return (
                <div key={index} className='mt-3'>
                  <div className='flex justify-between items-center  mt-2 mb-1 '>
                    <Typography variant='body1' color='primary'>
                      {Object.keys(pastData?.marks)[index]}
                    </Typography>
                    <Typography className='mr-2'>
                      Status:
                      {checkStatus(specificTestData)}
                    </Typography>
                  </div>
                  <ReusableMUITable
                    headerNames={[
                      'Subject',
                      'Total Marks',
                      'Obtained Marks',
                      'Grade',
                      'Status',
                    ]}
                    rowValues={[
                      { accessValue: 'subject' },
                      { accessValue: 'maxMarks' },
                      { accessValue: 'marks' },
                      { accessValue: 'grade' },
                      { accessValue: 'status' },
                    ]}
                    dataList={
                      pastData?.marks[Object.keys(pastData?.marks)[index]] ?? []
                    }
                  />
                </div>
              );
            })
          ) : (
            <Card className='flex items-center justify-center  min-h-44 border'>
              <Typography>
                No Previous Marks Details found for the Student
              </Typography>
            </Card>
          )}
          <div className=' text-end mt-5'>
            <Button
              variant='contained'
              color='success'
              className='ml-4'
              onClick={() => setOpen(false)}
            >
              OK
            </Button>
          </div>
        </div>
      </ModalDialog>
    </div>
  );
};
function checkStatus(data = []) {
  console.log(data);
  const bool = data.every((obj) => obj?.status?.toLowerCase() === 'pass');
  return bool ? (
    <Chip
      icon={<CheckCircle />}
      label='Pass'
      size='small'
      color='success'
      variant='outlined'
    />
  ) : (
    <Chip
      icon={<Cancel />}
      label='Fail'
      size='small'
      color='error'
      variant='outlined'
    />
  );
}
